import {
    LOGIN_USER,
    LOGIN_SUCCESS,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    API_ERROR,
    UPDATE_AVATAR,
    UPDATE_PROFILE,
    UPDATE_COMPANY,
    UPDATE_PASSWORD,
    UPDATE_PASSWORD_SUCCESS
} from "./actionTypes"
import { reactLocalStorage } from "reactjs-localstorage"

const storedProfile = reactLocalStorage.getObject('profile', null)

const initialState = {
    error: "",
    loading: false,
    profile: storedProfile || null
}

const login = (state = initialState, action) => {
    const { data } = action

    switch (action.type) {
        case LOGIN_USER:
            return {
                ...state,
                loading: true,
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                profile: data,
                loading: false,
            }
        case LOGOUT_USER:
            state = { ...state }
            break
        case LOGOUT_USER_SUCCESS:
            return { ...initialState, profile: null, loading: false }
        case API_ERROR:
            state = { ...state, error: action.payload, loading: false }
            break
        case UPDATE_PASSWORD:
            state = {
                ...state,
                loading: true
            }

            break
        case UPDATE_PASSWORD_SUCCESS:
            state = {
                ...state,
                success: true,
                loading: false
            }

            break
        case UPDATE_AVATAR:
            return {
                ...state,
                profile: {
                    ...(state.profile || {}),
                    user: { ...(state.profile?.user || {}), avatar: data }
                },
                loading: false
            }
        case UPDATE_PROFILE:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    user: data
                }
            }
        case UPDATE_COMPANY:
            return {
                ...state,
                profile: {
                    ...(state.profile || {}),
                    empresa: data
                }
            }
        default:
            return { ...state }
    }
    return state
}

export default login
